import { createContext, useContext, type PropsWithChildren } from "react";
import type { ContentConsentApi } from "../data/ContentConsentApi";

const Context = createContext<ContentConsentApi | null>(null);

export function ContentConsentProvider({ api, children }: PropsWithChildren<{ api: ContentConsentApi }>) {
  return <Context.Provider value={api}>{children}</Context.Provider>;
}

export function useContentConsentApi() {
  const value = useContext(Context);
  if (!value) throw new Error("useContentConsentApi must be used within ContentConsentProvider");
  return value;
}
